import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "flex items-center gap-2 mb-4"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = {
  class: "list-page-table-panel list-page-table-panel--fill"
};
const _hoisted_4 = {
  class: "filter-bar-field is-wide relative"
};
const _hoisted_5 = {
  class: "data-table-shell"
};
const _hoisted_6 = {
  class: "data-table-scroll data-table-scroll--fill"
};
const _hoisted_7 = {
  class: "data-table text-sm min-w-[960px]"
};
const _hoisted_8 = {
  key: 1
};
const _hoisted_9 = {
  class: "data-table-td"
};
const _hoisted_10 = {
  class: "flex items-start gap-3"
};
const _hoisted_11 = {
  class: "shrink-0"
};
const _hoisted_12 = {
  key: 0,
  class: "relative"
};
const _hoisted_13 = ["src"];
const _hoisted_14 = {
  key: 0,
  class: "absolute -bottom-1 -right-1 bg-black/60 text-white text-[10px] px-1 rounded"
};
const _hoisted_15 = {
  key: 1,
  class: "h-12 w-12 bg-slate-100 rounded-lg border border-slate-200 flex items-center justify-center"
};
const _hoisted_16 = {
  key: 1,
  class: "relative"
};
const _hoisted_17 = ["src"];
const _hoisted_18 = {
  key: 1,
  class: "h-12 w-12 bg-slate-900 rounded-lg flex items-center justify-center"
};
const _hoisted_19 = {
  class: "flex-1 min-w-0"
};
const _hoisted_20 = {
  class: "text-sm text-slate-900 line-clamp-2"
};
const _hoisted_21 = {
  class: "flex items-center gap-2 mt-1"
};
const _hoisted_22 = {
  key: 0,
  class: "inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-medium bg-orange-50 text-orange-600 border border-orange-200"
};
const _hoisted_23 = {
  key: 1,
  class: "inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-medium bg-blue-50 text-blue-600 border border-blue-200"
};
const _hoisted_24 = {
  class: "data-table-td"
};
const _hoisted_25 = {
  class: "flex items-center gap-2"
};
const _hoisted_26 = ["src"];
const _hoisted_27 = {
  key: 1,
  class: "w-6 h-6 rounded-full bg-primary-100 flex items-center justify-center shrink-0"
};
const _hoisted_28 = {
  class: "text-sm text-slate-700 truncate"
};
const _hoisted_29 = {
  class: "data-table-td"
};
const _hoisted_30 = {
  class: "data-table-td"
};
const _hoisted_31 = {
  class: "data-table-td"
};
const _hoisted_32 = {
  class: "data-table-td"
};
const _hoisted_33 = {
  class: "flex items-center gap-3 text-xs text-slate-500"
};
const _hoisted_34 = {
  class: "flex items-center gap-0.5",
  title: "浏览量"
};
const _hoisted_35 = {
  class: "flex items-center gap-0.5",
  title: "点赞数"
};
const _hoisted_36 = {
  class: "flex items-center gap-0.5",
  title: "收藏数"
};
const _hoisted_37 = {
  class: "data-table-td text-slate-500"
};
const _hoisted_38 = {
  class: "data-table-td is-center data-table-sticky-right data-table-sticky-action"
};
const _hoisted_39 = {
  class: "flex items-center justify-center gap-1"
};
const _hoisted_40 = ["onClick"];
const _hoisted_41 = ["onClick"];
const _hoisted_42 = ["onClick"];
const _hoisted_43 = ["onClick", "title", "aria-label"];
const _hoisted_44 = ["onClick"];
const _hoisted_45 = ["onClick"];
import { ref, onMounted } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import AppPagination from '@/components/AppPagination.vue';
import ListPageShell from '@/components/ListPageShell.vue';
import PageFilterBar from '@/components/PageFilterBar.vue';
import { usePagination } from '@/composables/usePagination';
import { useSearch } from '@/composables/useSearch';
import { getCirclePostPage, getCirclePostDetail, publishCirclePost, deleteCirclePost, onlineCirclePost, updateCirclePostTop, approveCirclePost, rejectCirclePost } from '@/api/circle';
import CirclePublishModal from './components/CirclePublishModal.vue';
import CircleDetailModal from './components/CircleDetailModal.vue';
import CircleTopModal from './components/CircleTopModal.vue';
import CircleRejectModal from './components/CircleRejectModal.vue';

// 数据

export default {
  __name: 'CircleManagement',
  setup(__props) {
    const loading = ref(false);
    const postList = ref([]);

    // 分页
    const {
      pagination,
      goToPage,
      setPageSize,
      updatePagination,
      getPaginationParams
    } = usePagination({
      pageSize: 10
    });

    // 搜索
    const {
      searchForm,
      resetSearch: _resetSearch,
      getSearchParams
    } = useSearch({
      initialForm: {
        source: '',
        contentType: '',
        status: '',
        keyword: ''
      },
      onSearch: fetchData
    });

    // 快捷筛选
    const activeQuickFilter = ref('');
    const quickFilters = [{
      key: '',
      label: '全部'
    }, {
      key: 'pending_user',
      label: '待审核'
    }, {
      key: 'platform',
      label: 'B端发布'
    }];
    const handleQuickFilter = key => {
      activeQuickFilter.value = key;
      if (key === 'pending_user') {
        searchForm.source = 0;
        searchForm.status = 0;
      } else if (key === 'platform') {
        searchForm.source = 1;
        searchForm.status = '';
      } else {
        searchForm.source = '';
        searchForm.status = '';
      }
      searchForm.contentType = '';
      searchForm.keyword = '';
      pagination.current = 1;
      fetchData();
    };
    const resetSearch = () => {
      activeQuickFilter.value = '';
      _resetSearch();
    };

    // 弹窗状态
    const showPublishModal = ref(false);
    const publishModalRef = ref();
    const showDetailModal = ref(false);
    const detailData = ref(null);
    const showTopModal = ref(false);
    const topModalRef = ref();
    const topTargetPost = ref(null);
    const showRejectModal = ref(false);
    const rejectModalRef = ref();
    const rejectTargetId = ref(null);

    // 来源选项
    const sourceOptions = [{
      label: '全部来源',
      value: ''
    }, {
      label: '用户',
      value: 0
    }, {
      label: '平台',
      value: 1
    }];

    // 内容类型选项
    const contentTypeOptions = [{
      label: '全部类型',
      value: ''
    }, {
      label: '图文',
      value: 1
    }, {
      label: '短视频',
      value: 2
    }];

    // 状态选项
    const statusOptions = [{
      label: '全部状态',
      value: ''
    }, {
      label: '待审核',
      value: 0
    }, {
      label: '已通过',
      value: 1
    }, {
      label: '已拒绝',
      value: 2
    }, {
      label: '已下架',
      value: 3
    }];

    // 状态配置
    const statusConfig = {
      0: {
        label: '待审核',
        dot: 'bg-amber-400',
        bg: 'bg-amber-50',
        text: 'text-amber-700'
      },
      1: {
        label: '已通过',
        dot: 'bg-green-500',
        bg: 'bg-green-50',
        text: 'text-green-700'
      },
      2: {
        label: '已拒绝',
        dot: 'bg-red-400',
        bg: 'bg-red-50',
        text: 'text-red-700'
      },
      3: {
        label: '已下架',
        dot: 'bg-slate-400',
        bg: 'bg-slate-100',
        text: 'text-slate-700'
      }
    };

    // 获取数据
    async function fetchData() {
      loading.value = true;
      try {
        const params = {
          ...getSearchParams(),
          ...getPaginationParams()
        };
        const data = await getCirclePostPage(params);
        postList.value = data.records || [];
        updatePagination(data);
      } catch (error) {
        ElMessage.error('加载动态列表失败');
        console.error('加载动态列表失败:', error);
      } finally {
        loading.value = false;
      }
    }

    // 筛选变更
    const handleFilterChange = () => {
      activeQuickFilter.value = '';
      pagination.current = 1;
      fetchData();
    };

    // 搜索
    const handleKeywordSearch = () => {
      activeQuickFilter.value = '';
      pagination.current = 1;
      fetchData();
    };

    // 换页
    const changePage = page => {
      goToPage(page);
      fetchData();
    };

    // 切换每页条数
    const changePageSize = size => {
      setPageSize(size);
      fetchData();
    };

    // 格式化时间
    const formatTime = time => {
      if (!time) return '-';
      return time.replace('T', ' ').substring(0, 16);
    };

    // 获取首张图片
    const getFirstImage = images => {
      if (!images) return '';
      return images.split(',')[0]?.trim() || '';
    };

    // 获取图片数量
    const getImageCount = images => {
      if (!images) return 0;
      return images.split(',').filter(url => url.trim()).length;
    };

    // ========== 操作 ==========

    // 发布动态
    const handlePublish = () => {
      showPublishModal.value = true;
    };
    const handlePublishConfirm = async data => {
      try {
        await publishCirclePost(data);
        ElMessage.success('发布成功');
        publishModalRef.value?.done();
        fetchData();
      } catch (error) {
        ElMessage.error(error.message || '发布失败');
        await publishModalRef.value?.fail();
      }
    };

    // 查看详情
    const handleViewDetail = async item => {
      try {
        const detail = await getCirclePostDetail(item.id);
        detailData.value = detail;
        showDetailModal.value = true;
      } catch (error) {
        ElMessage.error('获取详情失败');
      }
    };

    // 审核通过
    const handleApprove = async item => {
      try {
        await ElMessageBox.confirm('确定审核通过该动态吗？', '确认审核', {
          confirmButtonText: '通过',
          cancelButtonText: '取消',
          type: 'info'
        });
        await approveCirclePost(item.id);
        ElMessage.success('审核通过');
        fetchData();
      } catch (error) {
        if (error !== 'cancel') {
          ElMessage.error(error.message || '操作失败');
        }
      }
    };

    // 审核拒绝
    const handleReject = item => {
      rejectTargetId.value = item.id;
      showRejectModal.value = true;
    };
    const handleRejectConfirm = async data => {
      try {
        await rejectCirclePost(data.id, data);
        ElMessage.success('已拒绝');
        rejectModalRef.value?.done();
        fetchData();
      } catch (error) {
        ElMessage.error(error.message || '操作失败');
        rejectModalRef.value?.done();
      }
    };

    // 置顶操作
    const handleTop = item => {
      topTargetPost.value = item;
      showTopModal.value = true;
    };
    const handleTopConfirm = async data => {
      try {
        await updateCirclePostTop(data.id, data);
        ElMessage.success(data.isTop === 1 ? '已置顶' : '已取消置顶');
        topModalRef.value?.done();
        fetchData();
      } catch (error) {
        ElMessage.error(error.message || '操作失败');
        topModalRef.value?.done();
      }
    };

    // 重新上架
    const handleOnline = async item => {
      try {
        await ElMessageBox.confirm('确定要重新上架该动态吗？', '确认操作', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
        await onlineCirclePost(item.id);
        ElMessage.success('已重新上架');
        fetchData();
      } catch (error) {
        if (error !== 'cancel') {
          ElMessage.error(error.message || '操作失败');
        }
      }
    };

    // 删除
    const handleDelete = async item => {
      try {
        await ElMessageBox.confirm('确定要删除该动态吗？删除后无法恢复。', '确认删除', {
          confirmButtonText: '确认删除',
          cancelButtonText: '取消',
          type: 'warning'
        });
        await deleteCirclePost(item.id);
        ElMessage.success('删除成功');
        fetchData();
      } catch (error) {
        if (error !== 'cancel') {
          ElMessage.error(error.message || '删除失败');
        }
      }
    };
    onMounted(() => {
      fetchData();
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createBlock(ListPageShell, {
        fill: ""
      }, {
        header: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createElementVNode("div", {
          class: "list-page-panel is-header-minimal"
        }, [_createElementVNode("div", {
          class: "list-page-heading"
        }, [_createElementVNode("div", {
          class: "list-page-heading-main"
        }, [_createElementVNode("h1", {
          class: "list-page-title"
        }, "企业圈管理"), _createElementVNode("p", {
          class: "list-page-description"
        }, "管理企业圈动态内容，包括审核、置顶、发布等操作")])])], -1)]))]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(quickFilters, item => {
          return _createElementVNode("button", {
            key: item.key,
            onClick: $event => handleQuickFilter(item.key),
            class: _normalizeClass(['px-3 py-1.5 rounded-lg text-sm font-medium transition-colors cursor-pointer', activeQuickFilter.value === item.key ? 'bg-primary-700 text-white' : 'bg-white text-slate-600 border border-slate-200 hover:bg-slate-50'])
          }, _toDisplayString(item.label), 11, _hoisted_2);
        }), 64))]), _createElementVNode("div", _hoisted_3, [_createVNode(PageFilterBar, {
          "shell-class": "filter-bar-shell is-embedded",
          "body-class": "filter-bar-body is-panel",
          "show-refresh": true,
          "refresh-loading": loading.value,
          onRefresh: fetchData
        }, {
          searchActionsLeading: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("button", {
            onClick: handlePublish,
            class: "btn-primary"
          }, [...(_cache[10] || (_cache[10] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 4v16m8-8H4"
          })], -1), _createTextVNode(" 发布动态 ", -1)]))])), [[_directive_permission, 'app:circle:publish']])]),
          searchActions: _withCtx(() => [_createElementVNode("button", {
            type: "button",
            onClick: handleKeywordSearch,
            class: "btn-primary"
          }, "搜索"), _createElementVNode("button", {
            type: "button",
            onClick: resetSearch,
            class: "btn-secondary"
          }, "重置")]),
          default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(searchForm).keyword = $event),
            type: "text",
            placeholder: "搜索动态内容",
            class: "form-search-input form-control-sm w-full",
            onKeyup: _withKeys(handleKeywordSearch, ["enter"])
          }, null, 544), [[_vModelText, _unref(searchForm).keyword]]), _cache[9] || (_cache[9] = _createElementVNode("svg", {
            class: "absolute left-3 top-2.5 h-4 w-4 text-slate-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
          })], -1))]), _createVNode(_component_el_select, {
            modelValue: _unref(searchForm).source,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(searchForm).source = $event),
            placeholder: "请选择来源",
            class: "form-select form-control-sm filter-bar-field",
            onChange: handleFilterChange
          }, {
            default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(sourceOptions, opt => {
              return _createVNode(_component_el_option, {
                key: String(opt.value),
                label: opt.label,
                value: opt.value
              }, null, 8, ["label", "value"]);
            }), 64))]),
            _: 1
          }, 8, ["modelValue"]), _createVNode(_component_el_select, {
            modelValue: _unref(searchForm).contentType,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(searchForm).contentType = $event),
            placeholder: "请选择类型",
            class: "form-select form-control-sm filter-bar-field",
            onChange: handleFilterChange
          }, {
            default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(contentTypeOptions, opt => {
              return _createVNode(_component_el_option, {
                key: String(opt.value),
                label: opt.label,
                value: opt.value
              }, null, 8, ["label", "value"]);
            }), 64))]),
            _: 1
          }, 8, ["modelValue"]), _createVNode(_component_el_select, {
            modelValue: _unref(searchForm).status,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _unref(searchForm).status = $event),
            placeholder: "请选择状态",
            class: "form-select form-control-sm filter-bar-field",
            onChange: handleFilterChange
          }, {
            default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(statusOptions, opt => {
              return _createVNode(_component_el_option, {
                key: String(opt.value),
                label: opt.label,
                value: opt.value
              }, null, 8, ["label", "value"]);
            }), 64))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }, 8, ["refresh-loading"]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("table", _hoisted_7, [_cache[26] || (_cache[26] = _createElementVNode("thead", {
          class: "data-table-head"
        }, [_createElementVNode("tr", null, [_createElementVNode("th", {
          class: "data-table-th text-left"
        }, "动态内容"), _createElementVNode("th", {
          class: "data-table-th text-left w-32"
        }, "发布者"), _createElementVNode("th", {
          class: "data-table-th text-left w-20"
        }, "类型"), _createElementVNode("th", {
          class: "data-table-th text-left w-20"
        }, "来源"), _createElementVNode("th", {
          class: "data-table-th text-left w-20"
        }, "状态"), _createElementVNode("th", {
          class: "data-table-th text-left w-32"
        }, "互动数据"), _createElementVNode("th", {
          class: "data-table-th text-left w-36"
        }, "发布时间"), _createElementVNode("th", {
          class: "data-table-th text-center data-table-sticky-right data-table-sticky-head data-table-sticky-action"
        }, "操作")])], -1)), _createElementVNode("tbody", null, [loading.value ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, _renderList(5, n => {
          return _createElementVNode("tr", {
            key: n,
            class: "animate-pulse"
          }, [...(_cache[11] || (_cache[11] = [_createElementVNode("td", {
            class: "data-table-td"
          }, [_createElementVNode("div", {
            class: "flex gap-3"
          }, [_createElementVNode("div", {
            class: "h-12 w-12 bg-slate-200 rounded"
          }), _createElementVNode("div", {
            class: "flex-1"
          }, [_createElementVNode("div", {
            class: "h-4 bg-slate-200 rounded w-3/4 mb-2"
          }), _createElementVNode("div", {
            class: "h-3 bg-slate-200 rounded w-1/2"
          })])])], -1), _createElementVNode("td", {
            class: "data-table-td"
          }, [_createElementVNode("div", {
            class: "h-4 bg-slate-200 rounded w-16"
          })], -1), _createElementVNode("td", {
            class: "data-table-td is-center"
          }, [_createElementVNode("div", {
            class: "h-5 bg-slate-200 rounded w-12"
          })], -1), _createElementVNode("td", {
            class: "data-table-td is-center"
          }, [_createElementVNode("div", {
            class: "h-5 bg-slate-200 rounded w-14"
          })], -1), _createElementVNode("td", {
            class: "data-table-td is-center"
          }, [_createElementVNode("div", {
            class: "h-5 bg-slate-200 rounded w-14"
          })], -1), _createElementVNode("td", {
            class: "data-table-td"
          }, [_createElementVNode("div", {
            class: "h-4 bg-slate-200 rounded w-24"
          })], -1), _createElementVNode("td", {
            class: "data-table-td"
          }, [_createElementVNode("div", {
            class: "h-4 bg-slate-200 rounded w-28"
          })], -1), _createElementVNode("td", {
            class: "data-table-td is-center data-table-sticky-right data-table-sticky-action"
          }, [_createElementVNode("div", {
            class: "h-4 bg-slate-200 rounded w-24"
          })], -1)]))]);
        }), 64)) : _createCommentVNode("", true), !loading.value && postList.value.length === 0 ? (_openBlock(), _createElementBlock("tr", _hoisted_8, [...(_cache[12] || (_cache[12] = [_createElementVNode("td", {
          colspan: "8",
          class: "data-table-empty"
        }, [_createElementVNode("div", {
          class: "flex flex-col items-center"
        }, [_createElementVNode("div", {
          class: "empty-state-icon"
        }, [_createElementVNode("svg", {
          class: "w-8 h-8 text-slate-400",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "1.5",
          d: "M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z"
        })])]), _createElementVNode("p", {
          class: "empty-state-title"
        }, "暂无动态数据"), _createElementVNode("p", {
          class: "empty-state-desc"
        }, "点击右上方按钮发布新动态")])], -1)]))])) : _createCommentVNode("", true), !loading.value ? (_openBlock(true), _createElementBlock(_Fragment, {
          key: 2
        }, _renderList(postList.value, item => {
          return _openBlock(), _createElementBlock("tr", {
            key: item.id,
            class: "data-table-row"
          }, [_createElementVNode("td", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [item.contentType === 1 ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [getFirstImage(item.images) ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createElementVNode("img", {
            src: getFirstImage(item.images),
            class: "h-12 w-12 object-cover rounded-lg border border-slate-200"
          }, null, 8, _hoisted_13), getImageCount(item.images) > 1 ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(getImageCount(item.images)) + "图 ", 1)) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("div", _hoisted_15, [...(_cache[13] || (_cache[13] = [_createElementVNode("svg", {
            class: "w-5 h-5 text-slate-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "1.5",
            d: "M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
          })], -1)]))]))], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_16, [item.videoCover ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: item.videoCover,
            class: "h-12 w-12 object-cover rounded-lg border border-slate-200"
          }, null, 8, _hoisted_17)) : (_openBlock(), _createElementBlock("div", _hoisted_18, [...(_cache[14] || (_cache[14] = [_createElementVNode("svg", {
            class: "w-5 h-5 text-white",
            fill: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            d: "M8 5v14l11-7z"
          })], -1)]))])), _cache[15] || (_cache[15] = _createElementVNode("span", {
            class: "absolute bottom-0.5 right-0.5 bg-black/60 text-white flex items-center justify-center rounded w-4 h-4"
          }, [_createElementVNode("svg", {
            class: "w-2.5 h-2.5",
            fill: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            d: "M8 5v14l11-7z"
          })])], -1))]))]), _createElementVNode("div", _hoisted_19, [_createElementVNode("p", _hoisted_20, _toDisplayString(item.content || '（无文字内容）'), 1), _createElementVNode("div", _hoisted_21, [item.isTop === 1 ? (_openBlock(), _createElementBlock("span", _hoisted_22, " 置顶 ")) : _createCommentVNode("", true), item.linkUrl ? (_openBlock(), _createElementBlock("span", _hoisted_23, " 含链接 ")) : _createCommentVNode("", true)])])])]), _createElementVNode("td", _hoisted_24, [_createElementVNode("div", _hoisted_25, [item.userAvatar ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: item.userAvatar,
            class: "w-6 h-6 rounded-full object-cover border border-slate-200"
          }, null, 8, _hoisted_26)) : (_openBlock(), _createElementBlock("div", _hoisted_27, [...(_cache[16] || (_cache[16] = [_createElementVNode("svg", {
            class: "w-3 h-3 text-primary-600",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
          })], -1)]))])), _createElementVNode("span", _hoisted_28, _toDisplayString(item.userNickname || '-'), 1)])]), _createElementVNode("td", _hoisted_29, [_createElementVNode("span", {
            class: _normalizeClass(['status-badge', item.contentType === 1 ? 'status-badge is-purple' : 'status-badge is-cyan'])
          }, _toDisplayString(item.contentType === 1 ? '图文' : '短视频'), 3)]), _createElementVNode("td", _hoisted_30, [_createElementVNode("span", {
            class: _normalizeClass(['status-badge', item.source === 0 ? 'status-badge is-info' : 'status-badge is-indigo'])
          }, _toDisplayString(item.source === 0 ? '用户' : '平台'), 3)]), _createElementVNode("td", _hoisted_31, [_createElementVNode("span", {
            class: _normalizeClass(["status-badge", [statusConfig[item.status]?.bg, statusConfig[item.status]?.text]])
          }, [_createElementVNode("span", {
            class: _normalizeClass(["w-1.5 h-1.5 rounded-full mr-1.5", statusConfig[item.status]?.dot])
          }, null, 2), _createTextVNode(" " + _toDisplayString(statusConfig[item.status]?.label || '未知'), 1)], 2)]), _createElementVNode("td", _hoisted_32, [_createElementVNode("div", _hoisted_33, [_createElementVNode("span", _hoisted_34, [_cache[17] || (_cache[17] = _createElementVNode("svg", {
            class: "w-3.5 h-3.5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
          }), _createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
          })], -1)), _createTextVNode(" " + _toDisplayString(item.viewCount || 0), 1)]), _createElementVNode("span", _hoisted_35, [_cache[18] || (_cache[18] = _createElementVNode("svg", {
            class: "w-3.5 h-3.5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
          })], -1)), _createTextVNode(" " + _toDisplayString(item.likeCount || 0), 1)]), _createElementVNode("span", _hoisted_36, [_cache[19] || (_cache[19] = _createElementVNode("svg", {
            class: "w-3.5 h-3.5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"
          })], -1)), _createTextVNode(" " + _toDisplayString(item.favoriteCount || 0), 1)])])]), _createElementVNode("td", _hoisted_37, _toDisplayString(formatTime(item.createTime)), 1), _createElementVNode("td", _hoisted_38, [_createElementVNode("div", _hoisted_39, [_withDirectives((_openBlock(), _createElementBlock("button", {
            onClick: $event => handleViewDetail(item),
            class: "table-action-button is-primary",
            title: "查看详情",
            "aria-label": "查看详情"
          }, [...(_cache[20] || (_cache[20] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
          }), _createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
          })], -1)]))], 8, _hoisted_40)), [[_directive_permission, 'app:circle:list']]), item.status === 0 ? _withDirectives((_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: $event => handleApprove(item),
            class: "table-action-button is-success",
            title: "审核通过",
            "aria-label": "审核通过"
          }, [...(_cache[21] || (_cache[21] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M5 13l4 4L19 7"
          })], -1)]))], 8, _hoisted_41)), [[_directive_permission, 'app:circle:audit']]) : _createCommentVNode("", true), item.status === 0 ? _withDirectives((_openBlock(), _createElementBlock("button", {
            key: 1,
            onClick: $event => handleReject(item),
            class: "table-action-button is-danger",
            title: "审核拒绝",
            "aria-label": "审核拒绝"
          }, [...(_cache[22] || (_cache[22] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))], 8, _hoisted_42)), [[_directive_permission, 'app:circle:audit']]) : _createCommentVNode("", true), item.status === 1 ? _withDirectives((_openBlock(), _createElementBlock("button", {
            key: 2,
            onClick: $event => handleTop(item),
            class: "table-action-button is-teal",
            title: item.isTop === 1 ? '取消置顶' : '设置置顶',
            "aria-label": item.isTop === 1 ? '取消置顶' : '设置置顶'
          }, [...(_cache[23] || (_cache[23] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M5 15l7-7 7 7"
          })], -1)]))], 8, _hoisted_43)), [[_directive_permission, 'app:circle:edit']]) : _createCommentVNode("", true), item.status === 3 ? _withDirectives((_openBlock(), _createElementBlock("button", {
            key: 3,
            onClick: $event => handleOnline(item),
            class: "table-action-button is-success",
            title: "重新上架",
            "aria-label": "重新上架"
          }, [...(_cache[24] || (_cache[24] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
          })], -1)]))], 8, _hoisted_44)), [[_directive_permission, 'app:circle:edit']]) : _createCommentVNode("", true), _withDirectives((_openBlock(), _createElementBlock("button", {
            onClick: $event => handleDelete(item),
            class: "table-action-button is-danger",
            title: "删除",
            "aria-label": "删除"
          }, [...(_cache[25] || (_cache[25] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
          })], -1)]))], 8, _hoisted_45)), [[_directive_permission, 'app:circle:delete']])])])]);
        }), 128)) : _createCommentVNode("", true)])])])]), _unref(pagination).total > 0 ? (_openBlock(), _createBlock(AppPagination, {
          key: 0,
          class: "pagination-bridge",
          pagination: _unref(pagination),
          "page-sizes": [10, 20, 50],
          onPageChange: changePage,
          onSizeChange: changePageSize
        }, null, 8, ["pagination"])) : _createCommentVNode("", true)]), _createVNode(CirclePublishModal, {
          ref_key: "publishModalRef",
          ref: publishModalRef,
          show: showPublishModal.value,
          "onUpdate:show": _cache[4] || (_cache[4] = $event => showPublishModal.value = $event),
          onConfirm: handlePublishConfirm
        }, null, 8, ["show"]), _createVNode(CircleDetailModal, {
          show: showDetailModal.value,
          "onUpdate:show": _cache[5] || (_cache[5] = $event => showDetailModal.value = $event),
          "post-data": detailData.value
        }, null, 8, ["show", "post-data"]), _createVNode(CircleTopModal, {
          ref_key: "topModalRef",
          ref: topModalRef,
          show: showTopModal.value,
          "onUpdate:show": _cache[6] || (_cache[6] = $event => showTopModal.value = $event),
          "post-data": topTargetPost.value,
          onConfirm: handleTopConfirm
        }, null, 8, ["show", "post-data"]), _createVNode(CircleRejectModal, {
          ref_key: "rejectModalRef",
          ref: rejectModalRef,
          show: showRejectModal.value,
          "onUpdate:show": _cache[7] || (_cache[7] = $event => showRejectModal.value = $event),
          "post-id": rejectTargetId.value,
          onConfirm: handleRejectConfirm
        }, null, 8, ["show", "post-id"])]),
        _: 1
      });
    };
  }
};